module.exports = __webpack_public_path__ + "images/emoji/sun_with_face.89250bd2bdafeb53826f.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/sun_with_face.png
// module id = Vxrr
// module chunks = 1